/* eslint-disable default-case */
/* eslint-disable no-fallthrough */
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "../Shared/Button";
import Form from "react-bootstrap/Form";
import { addPitch, addProject, registerInterest } from "../../Datahandler";
import "./modalPopUp.css";
import { useDispatch, useSelector } from "react-redux";
import extractNamesFromEmail from "../../utils/extractNameFromEmail";
import CreatePitchModal from "./CreatePitchModal";
import { setInProgressPitch } from "./CreatePitchModal/redux/actions";
import CreateProjectModal from "./CreateProjectModal";
import { setInProgressProject } from "./CreateProjectModal/redux/actions";
import { addToast } from "../Shared/Toasts/redux/actions";
import { useNavigate } from "react-router-dom";

const ModalPopup = ({
  show,
  handleClose,
  description,
  image,
  title,
  type,
  contact,
  date,
}) => {
  const [email, setEmail] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const currentUser = useSelector((state) => state.user.loggedInUser);
  const inProgressPitch = useSelector(
    (state) => state.createPitch.inProgressPitch
  );
  const inProgressProject = useSelector(
    (state) => state.createProject.inProgressProject
  );

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = () => {
    switch (type) {
      case "form":
        registerInterest(email);
      case "createPitch":
        addPitch(
          inProgressPitch.pitchTitle,
          inProgressPitch.pitchDescription,
          extractNamesFromEmail(currentUser.email),
          inProgressPitch.pitchLink,
          currentUser.uid,
          inProgressPitch.pitchLevel,
          inProgressPitch.uid
        )
          .then(() => {
            dispatch(
              addToast({
                header: "Success",
                body: `${inProgressPitch.pitchTitle} successfully updated`,
                time: Date.now(),
                status: "success",
                id: crypto.randomUUID(),
              })
            );
            dispatch(setInProgressPitch(null));
            handleClose();
          })
          .catch((e) => {
            dispatch(
              addToast({
                header: "Failure",
                body: `Pitch failed to update. ${e}`,
                time: Date.now(),
                status: "failure",
                id: crypto.randomUUID(),
              })
            );
          });
        dispatch(setInProgressPitch(null));
      case "createProject":
        addProject(
          inProgressProject.title,
          inProgressProject.description,
          extractNamesFromEmail(currentUser.email),
          currentUser.uid,
          inProgressProject.gitUrl,
          inProgressProject.members,
          inProgressProject.videoUrl,
          inProgressProject.level,
          inProgressProject.status,
          inProgressProject.uid,
          inProgressProject.imgUrl
        )
          .then(() => {
            dispatch(
              addToast({
                header: "Success",
                body: `${inProgressProject.projectTitle} successfully updated`,
                time: Date.now(),
                status: "success",
                id: crypto.randomUUID(),
              })
            );
            navigate(`/projs/${inProgressProject.projectTitle}`);
            dispatch(setInProgressProject(null));
            handleClose();
          })
          .catch((e) => {
            dispatch(
              addToast({
                header: "Failure",
                body: `Project failed to update. ${e}`,
                time: Date.now(),
                status: "failure",
                id: crypto.randomUUID(),
              })
            );
          });
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="xl">
      <Modal.Header closeButton>
        <Modal.Title className={"modalHeader"}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body
        className={`${
          type !== "createPitch" ? "modalContent" : "modalCreatePitch"
        }`}
      >
        {contact && date && (
          <p className={"modalAuthor"}>
            {contact} - {date}
          </p>
        )}
        <section
          className={
            !type.includes("create") ? "modalInformation" : "modalCreatePitch"
          }
        >
          {image && (
            <img
              className={"modalImage"}
              src={image}
              alt="your-image-alt-text-here"
            />
          )}
          <section
            className={type.includes("create") ? "modalPitchSection" : ""}
          >
            <p>{description}</p>
            {type === "form" && (
              <Form>
                <Form.Group controlId="formBasicEmail">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter email"
                    value={email}
                    onChange={handleEmailChange}
                  />
                  <Form.Text className="text-muted">
                    We'll never share your email with anyone else.
                  </Form.Text>
                </Form.Group>
              </Form>
            )}
            {type === "createPitch" && <CreatePitchModal />}
            {type === "createProject" && <CreateProjectModal />}
          </section>
        </section>
      </Modal.Body>
      <Modal.Footer className={"modalFooter"}>
        <Button
          buttonStyle="pink-transparent"
          text="Close"
          onClick={handleClose}
        />
        {type === "form" && (
          <Button text="Send" buttonStyle="pink" onClick={handleSubmit} />
        )}
        {type.includes("create") && (
          <Button text="Submit" buttonStyle="pink" onClick={handleSubmit} />
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ModalPopup;
